export default __webpack_public_path__ + "static/media/complete.03d21cd7.svg";